export const fa = {
  //home page
  LoadMoreProduct: 'محصولات بیشتر',
  btn2: 'نظرات بیشتر',
  btn4: 'اطلاعات بیشتر درباره ما',
  Result: `راهکارهای نرم‌افزاری `,

  Digital: 'متناسب با رشد شما',
  Solution: `هوشمند `,
  provide:
    'نیازهای کسب‌وکار شما را به نرم‌افزاری قابل‌اعتماد تبدیل می‌کنیم: محصولات سفارشی، پلتفرم‌های وب و اپلیکیشن‌های موبایل، با تیمی باتجربه.',
  ourServices: 'خدمات ما',
  TopProducts: `
        محصولات برتر `,
  CustomerFeedback: 'بازخورد مشتریان',
  textAboutUs:
    'شرکت  پیشتازان دیجیتال نوا  با شماره ثبت 5902  در سال 1397 کار خود را آغاز کرد که موسسان این شرکت با بیش از ده سال سابقه در زمینه برنامه نویسی و محیط استارتاپی کشور با استفاده از تجربیات خود و دیگران ، شروع به تأسیس کردند. ',
  textAboutUsIP:
    'شرکت نوا با شماره ثبت۱۶۱۵۴۷۷۸ کار خود را در سال ۲۰۱۸ آغاز کرد. بنیانگذاران این شرکت با بیش از ده سال سابقه در حوزه برنامه‌نویسی و فضای استارتاپی کشور، با استفاده از تجربیات خود و دیگران، اقدام به تأسیس شرکت کردند.',
  OurProcess: 'فرآیند ما',
  OurTrustedPartner: 'شرکاء مورد اعتماد ما',
  Explore: 'ایده های کسب و کار خود را با استراتژی های مدرن ما کشف کنید',
  team: 'تیم ما آماده است تا با استراتژی های دیجیتال مارکتینگ خلاقانه و مدرن به شما در دستیابی به اهداف تجاری خود کمک کند.',

  text1: 'گواهینامه',

  blog: 'بلاگ ها',

  ReadMore: `
        بیشتر بخوانید `,
  //header
  Home: 'صفحه اصلی',

  Products: 'محصولات',

  Projects: 'پروژه ها',

  Blogs: 'بلاگ ها',

  AboutUs: 'درباره ما',

  ContactUs: 'ارتباط با ما',

  ChangeLang: 'تغییر زبان به',

  SwitchMode: 'تغییر پس زمینه به',
  mode1: 'حالت تاریک',
  mode2: 'حالت روشن',
  footerText: 'شرکت  پیشتازان دیجیتال نوا  با شماره ثبت 5902  کار خود را در سال 1397 آغاز کرد.',

  QuickLinks: 'دسترسی سریع',

  Support: 'ارتباط',
  Certification: 'گواهینامه',
  allJob: 'فرصت شغلی',
  Address: 'آدرس',
  //about us page
  aboutText1: 'شرکت  پیشتازان دیجیتال نوا ',
  aboutText2:
    'ما در شرکت  پیشتازان دیجیتال نوا  به قدرت دیجیتال مارکتینگ اعتقاد داریم و به شما کمک می کنیم تا با استفاده از استراتژی های جدید برند خود را به اوج برسانید. از زمان تاسیس ما در سال 2019، هدف ما ارائه راه حل های نوآورانه و موثر در دنیای دیجیتال بوده است. با تیمی از کارشناسان و تجربیات موفق در زمینه های مختلف، ما به شما کمک می کنیم تا به صورت آنلاین برجسته شوید.',
  aboutText3: 'ماموریت ما',
  aboutblog: `
        ماموریت ما ترویج برندها و کسب و کارها از طریق استراتژی های مدرن و خلاقانه است.ما به شما کمک می کنیم تا با استفاده از فناوری و نوآوری های دیجیتال به اهداف تجاری خود برسید.
        `,
  aboutText5: `
        چشم انداز شرکت `,
  aboutText6: `
        در حال حاضر برنامه این شرکت بر روی توسعه محصولات خارجی(اپلیکیشن ها و وب سایت ها) و تمرکز بر حوزه های هوش مصنوعی و انجام پروژه های اتوماسیون داخلی است.
        `,

  aboutText7: 'جوایز و افتخارات',
  aboutText8: ' کاندیدای نهایی بهترین اپلیکیشن جشنواره اپ و موبایل ایران در سال ۱۳۹۷',
  aboutText9: 'کاندیدای نهایی طرح برتر جشنواره استان آپ کشوری در سال ۱۴۰۰',
  //detailBlog
  RelatedPost: 'پست های مرتبط',
  loadMoreBlog: 'بارگیری بلاگ بیشتر',
  //Job
  JobOpportunities: 'فرصت شغلی',
  closed: 'بسته است',
  LoadMoreJobs: 'نمایش فرصت‌های شغلی بیشتر',

  //product
  ViewProduct: 'مشاهده محصول',
  ViewProject: 'مشاهده پروژه',
  gallery: 'گالری محصول',
  TopFeatures: 'ویژگی های برتر',
  TechnicalDetails: 'جزئیات فنی',
  OtherFeatures: ' سایر ویژگی ها',
  Product: '',
  downloadApplication: 'دانلود اپلیکیشن',
  Purpose: 'هدف محصول',
  //jobDes
  JobDescription: 'توضیحات شغل',
  palaseHolderName: 'نام خود را وارد کنید',
  palaseHolderFamily: ' نام خانوادگی خود را وارد کنید',
  palaseHolderEmail: 'ایمیل خود را وارد کنید',
  palaseHolderPhone: 'شماره تلفن خود را وارد کنید',
  labelName: 'نام',
  labelLastName: 'نام خانوادگی',
  labelEmail: 'ایمیل',
  labelNumber: 'شماره تلفن',
  send: 'ارسال',
  CV: 'بارگذاری رزومه',
  Upload: 'بارگذاری فایل',
  Max: 'حداکثر حجم فایل: ۳۰ مگابایت',
  //contact page
  Message: 'پیام شما',
  Message2: 'پیام خود را وارد کنید',
  email: 'ارتباط از طریق ایمیل',
  phone: 'ارتباط از طریق تماس تلفنی',
  whatsapp:'ارتباط از طریق واتساپ',

  phoneRequired: 'لطفاً شماره تلفن را وارد کنید',
  phoneInvalid: 'شماره تلفن وارد شده معتبر نیست',
  emailRequired: 'لطفاً ایمیل را وارد کنید',
  emailInvalid: 'فرمت ایمیل نادرست است',
  nameRequired: 'لطفاً نام خود را وارد کنید',
  lastNameRequired: 'لطفاً نام خانوادگی خود را وارد کنید',
  textRequired: 'لطفاً  متن را وارد کنید',
  fileTypeInvalid: 'فقط فایل‌های PDF، PNG و JPG مجاز هستند.',
  fileTooLarge: 'حجم فایل نباید بیشتر از ۳۰ مگابایت باشد.',
  allowedFiles: 'فرمت‌های مجاز: PDF، PNG، JPG',
  seoDescription: 'نوآ محصولات نرم‌افزاری، پلتفرم‌های وب و اپلیکیشن‌های موبایل را برای کسب‌وکارهای در حال رشد طراحی و توسعه می‌دهد.',
  fileRequired: 'لطفاً فایل را انتخاب کنید',
  Loading: 'در حال بارگذاری…',
  SuccessMessage: 'ممنونیم! اطلاعات شما دریافت شد و به‌زودی با شما تماس می‌گیریم.',
  errorMessage: 'مشکلی پیش آمد. لطفاً اطلاعات را بررسی کنید و دوباره تلاش کنید.',
  errorServerMessage: 'سرور در حال حاضر پاسخ نمی‌دهد. لطفاً چند دقیقه دیگر دوباره تلاش کنید.',
  DownloadResome: 'دانلود پورتفولیو',
  footerTextIp:
    'شرکت نووا با شماره ثبت ۱۶۱۵۴۷۷۸، یک شرکت فناوری پیشرو و متخصص در توسعه نرم‌افزارهای وب و موبایل است. تمرکز ما بر طراحی و ساخت اپلیکیشن‌های باکیفیت iOS و اندروید، به همراه وب‌سایت‌های پیشرفته متناسب با نیازهای دنیای دیجیتالِ به سرعت در حال تکامل امروزی است.',
  visitWebsite: 'بازدید از وب سایت',
  download:'دانلود',
  
  androidVersion: "دانلود نسخه اندروید ",
  iosVersion: "دانلود نسخه iOS",
  networkError: 'اتصال برقرار نشد. اینترنت خود را بررسی کنید و دوباره تلاش کنید.',
  sending: 'در حال ارسال…',
  textInvalid: 'پیام شما شامل نویسه‌های نامعتبر است',
  remote: 'دورکاری',
  view: 'مشاهده',
  noItems: 'هنوز موردی برای نمایش وجود ندارد. به‌زودی دوباره سر بزنید.',
  backToJobs: 'همه فرصت‌های شغلی',
  aboutRole: 'درباره این موقعیت',
  applyNow: 'درخواست همکاری',
  applyHint: 'مشخصات و رزومه خود را برای ما بفرستید. به همه درخواست‌ها پاسخ می‌دهیم.',
  seoProducts: 'محصولات و پلتفرم‌های نرم‌افزاری نوآ: اپلیکیشن وب، موبایل و دسکتاپ برای کسب‌وکارهای در حال رشد.',
  seoProjects: 'نمونه پروژه‌های انجام‌شده توسط نوآ: وب‌سایت، اپلیکیشن موبایل و نرم‌افزار سفارشی برای کسب‌وکارهای واقعی.',
  seoBlog: 'مقاله‌های تیم نوآ درباره توسعه وب، اپلیکیشن موبایل، طراحی رابط و تجربه کاربری، سئو، هوش مصنوعی و امنیت.',
  seoAbout: 'با نوآ، ماموریت، چشم‌انداز و تیمی که برای کسب‌وکارها محصول نرم‌افزاری می‌سازد آشنا شوید.',
  seoContact: 'برای گفتگو درباره وب‌سایت، اپلیکیشن موبایل یا نرم‌افزار سفارشی خود با نوآ تماس بگیرید.',
  seoJobs: 'فرصت‌های شغلی نوآ. به تیمی دورکار که محصولات نرم‌افزاری می‌سازد بپیوندید.',
  seoCertification: 'گواهینامه‌ها و جوایز نوآ.',
  seoFeedback: 'نظر مشتریان درباره همکاری با نوآ.',
};
